import { accountService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, accounts: [], account: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        accountService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        accountService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/accounts');
                    dispatch('alert/success', "Account Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/accounts');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        accountService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/accounts');
                    dispatch('alert/success', "Account Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/accounts');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        accountService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      accountService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/accounts');
                  dispatch('alert/success', "Account Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/accounts');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_available_parent_accounts({ dispatch, commit }) {
        commit('request');

        accountService.get_available_parent_accounts()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  accounts: state => {
    return state.accounts
  },
  account: state => {
    return state.account
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.account = {};
        state.accounts = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.account = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.accounts = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const accounts = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
